import { render, staticRenderFns } from "./SendDocuments.vue?vue&type=template&id=d9c777a4&"
import script from "./SendDocuments.vue?vue&type=script&lang=js&"
export * from "./SendDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports